import { render, staticRenderFns } from "./uploadCredentials.vue?vue&type=template&id=322a93d6&scoped=true"
import script from "./uploadCredentials.vue?vue&type=script&lang=js"
export * from "./uploadCredentials.vue?vue&type=script&lang=js"
import style0 from "./uploadCredentials.vue?vue&type=style&index=0&id=322a93d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a93d6",
  null
  
)

export default component.exports